import { ICharacter } from "@next-platform/client-common-core";

import { NSFW_TAGS } from "@/constants";
import { IRecommItems } from "@/hooks/types";
import { HitItem } from "@/types/hits";

import { compareFunctionToSort, modifyHitsToAddRecommId } from "./";

interface IGetCharacterHitsProps {
  hits: ICharacter[];
  isAuthLoading: boolean;
  shouldInjectRecommendations: boolean;
  recommendations: IRecommItems | null;
  recommId: string;
  searchedQuery: string | undefined;
  shouldFilterNsfwCharacters: boolean;
}

export const isNsfwCharacter = (character: ICharacter): boolean => !!character.is_nsfw || !!character.tags?.some((tag) => NSFW_TAGS.includes(tag));

export const filterOutNsfwCharacters = (characters: ICharacter[]): ICharacter[] => characters.filter((character) => !isNsfwCharacter(character));

export function getCharacterHits({
  hits,
  isAuthLoading,
  shouldInjectRecommendations,
  recommendations,
  recommId,
  searchedQuery,
  shouldFilterNsfwCharacters,
}: IGetCharacterHitsProps): HitItem[] | null {
  if (isAuthLoading) {
    return null;
  }

  let processedHits = [...hits];

  if (shouldInjectRecommendations && recommendations?.recomms?.length) {
    processedHits = modifyHitsToAddRecommId(hits, recommendations).sort(compareFunctionToSort);
  } else if (recommId) {
    processedHits = hits.map((char) => ({ ...char, recommId }));
  }

  if (shouldFilterNsfwCharacters) {
    processedHits = filterOutNsfwCharacters(processedHits);
  }

  if (searchedQuery) {
    return processedHits;
  }

  return processedHits?.length ? processedHits : null;
}
